const fr = {
  header: {
    acceuil: 'Accueil',
    aProposDuCentre: 'A propos du centre',
    demandeSalle: 'Réserver une salle',
    nousContacter: 'Nous contacter',
    lang: 'English',
    // portail: 'Portail de résérvation de salle',
    // portailOtherLang: 'Room booking portal',
    portail: 'Centre de simulation Marrakech',
    portailOtherLang: 'M.T.C',
  },
  accueil: {
    landingTitle: 'Centre de simulation et d’innovation en sciences de la santé',
    landingSubtitle: 'Nous offrons un environnement de formation immersif et réaliste grâce à des technologies de pointe et des scénarios cliniques simulés.',
    buttonLanding: 'A propos de nous',
    procedure: 'Procédure',
    demandeReservationSalle: 'Demande de résérvation de salle',
    suivreEtatDemande: 'Suivre l’état de votre demande',
    confirmationDemande: 'Confirmation de votre présence',
    commentSimulationPeutAider: 'Comment la simulation peut vous aider ?',
    developpezCompetence: 'Développez des compétences cliniques en toute sécurité',
    experienceApprentissage: 'Offrez une expérience d\'apprentissage plus engageante',
    encouragezInteractivite: 'Encouragez l’interactivité et l’esprit d’équipe',
  },
  aproposCentre: {
    aproposCentre: 'A propos du centre :',
    aproposCentreContent: 'Bienvenue au Centre de Simulation et d\'Innovation en Science de la Santé, un lieu dédié à l\'excellence en formation et en recherche dans le domaine des sciences de la santé. Notre centre offre un environnement de formation immersif et réaliste grâce à des technologies de pointe et des scénarios cliniques simulés.',
    notreMission: 'Notre Mission :',
    notreMissionContent: 'Notre mission est de former les professionnels de la santé de demain en leur fournissant les compétences nécessaires pour répondre aux défis du monde réel. Nous croyons que la pratique dans un environnement contrôlé et sûr améliore non seulement les compétences techniques, mais aussi la communication, le travail d\'équipe et la prise de décision sous pression.',
    nosInstallations: 'Nos Installations :',
    nosInstallationsItem1: 'Simulateurs Haute Fidélité : Utilisation de mannequins sophistiqués qui reproduisent des conditions physiologiques et pathologiques réelles.',
    nosInstallationsItem2: 'Scénarios Immersifs : Création de scénarios cliniques réalistes pour une formation pratique intensive.',
    nosInstallationsItem3: 'Technologies Avancées : Intégration de la réalité virtuelle et augmentée pour une expérience d\'apprentissage enrichie.',
    nosInstallationsItem4: 'Laboratoires de Recherche : Facilitation de la recherche innovante en techniques de simulation et en pédagogie médicale.',
    revenirPageAccueil: 'Revenir à la page d’accueil',
  },
  nousContacter: {
    nousContacter: 'Nous contacter :',
    nomPrenom: 'Nom et prénom',
    numeroTelephone: 'Numéro du téléphone',
    objet: 'Objet',
    message: 'Message',
    envoyer: 'Envoyer',
    messageSuccess : 'votre message a bien été envoyé',
  },
  reservationSalle: {
    demandeReservationSalle: 'Demande de résérvation de salle',
    suivreEtatDemande: 'Suivre l’état de votre demande',
    confirmationDemande: 'Confirmation de votre présence',
    cin: 'CIN',
    departement: 'Département',
    nomPrenomFormateur: 'Nom et prénom du formateur',
    nomPrenomAssistantFormateur: 'Nom et prénom de l\'assistant du formateur',
    programmeFormation: 'programme de la formation',
    materiel: 'Matériel pédagogique souhaitable',
    consommables: 'Consommables',
    nombreParticipant: 'Nombre de participant',
    typeApprentis: 'type d\'apprentis',
    typeApprentisItems: ['externes', 'médecins résidents', 'médecins internes'],
    choisirDateReservationSalle: 'Choisir la date de réservation de la salle :',
    annee: 'Année',
    mois: 'Mois',
    moisItems: [
      'Janvier', 'Février', 'Mars', "Avril", 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ],
    confirmer: 'Confirmer',
    numeroDemande: 'Numéro de demande',
    consulterEtatDemande: 'Consulter l’état de ma demande',
    oublierNumeroDemandeInfo: 'Si vous avez oublié votre numéro de demande, merci de contacter l’équipe administrative du centre de simulation ou bien contactez-nous via la page dédiée',
    faireAutreDemande: 'Faire une autre demande de réservation de salle',
    annulerDemande: 'J’annule ma demande',
    confirmerPresence: 'Je confirme ma présence',
    successDemande: 'votre demande a bien été enregistrée',
    votreDemandeNumero: 'Votre demande numéro',
    enCoursTraitement: 'est en cours de traitement',
    rejete: 'a été rejetée. ',
    information: '\nInformation: ',
    statutDialogTitle: 'Numéro de demande :',
    statutDialgoContent: 'Merci de noter ce numéro pour pouvoir consulter votre demande la prochine fois',
    cinNumeroDemandeIncorrecte: 'cin ou numéro de demande est incorrectee',
    votreDemandeReservationSalle: 'Votre demande de réservation de salle du',
    demandeAccepted: 'a été accépté merci de confirmer votre présence',
    confirmationPresence: 'Confirmation de Présence :',
    annulationDemande: 'Annulation de demande :',
    presenceEnregistre: 'Votre présence a bien été enregistrée',
    demandeAnnule: 'Votre demande a bien été annulée',
    demandeCanceled: 'Cette demande a été annulée. Merci de créer une autre',
    inputError: 'Merci de corriger les erreurs',
  },
  firstWorldCup: {
    jour: 'J',
    heure: 'H',
    minute: 'Min',
    seconde: 'S',
    alaune: 'À la une',
    worldcup: 'WORLDCUP IN PEDIATRIC SIMULATION',
    dateWorldcup: 'Du 03-06 juillet 2025',
    firstEdition: 'Première édition Marrakech',
    enSavoirPlus: 'En savoir plus sur l\'événement',
    participerEvent: 'Participer à l\'événement',
    soumission: 'Soumission',
    inscription: 'Inscription',
    inscriptionNotStudent: 'Inscription (Résident, spécialiste, paramédical)',
    inscriptionStudentSpectateur: 'Spéctateur',
    typeParticipation: 'type de participation',
    typeParticipationItems: ['Participant', 'Spéctateur'],
    inscriptionStudentAttelier: 'Atelier',
    inscriptionStudentCompetition: 'Compétition',
    participerStudentEvent: 'Participer à l\'événement en tant que étudiant',
    inscriptionStudent: 'Inscription (Etudiant)',
    soumissionSuccess: 'Votre soumission a été transmise avec succès.',
    soumissionError: 'Merci de corriger les erreurs',
    soumissionTitle: 'Soumettez votre contribution et partagez vos innovations en simulation médicale :',
    titre: 'Titre',
    auteur: 'Auteur',
    coAuteur: 'Co-auteur',
    typeSoumission: 'Type de soumission',
    email: 'E-mail',
    pays: 'Pays',
    paysItems: ['Maroc', 'Autre'],
    ville: 'Ville',
    specialite: 'Spécialité',
    nationalite: 'Continent',
    nationaliteItems: ['Afrique', 'Europe', 'Amérique', 'Asie'],
    profession: 'Catégorie',
    professionItems: ['Etudiant', 'Résident', 'Spécialiste', 'Para médical'],
    inscriptionContent: [
      'Votre inscription a bien été prise en compte !',
      'Nous vous avons envoyé un e-mail contenant toutes les informations nécessaires pour finaliser votre inscription, y compris les détails de paiement. Veuillez consulter votre boîte de réception (et éventuellement votre dossier spam) pour accéder à ces informations.',
      'Si vous avez des questions ou rencontrez des difficultés, n\'hésitez pas à nous contacter.',
      'Merci et à bientôt !'
    ],
    soumissionContent: [
      'Votre soumission a bien été prise en compte !',
      'Nous vous avons envoyé un e-mail contenant toutes les informations nécessaires pour finaliser votre soumission, y compris les détails de paiement. Veuillez consulter votre boîte de réception (et éventuellement votre dossier spam) pour accéder à ces informations.',
      'Si vous avez des questions ou rencontrez des difficultés, n\'hésitez pas à nous contacter.',
      'Merci et à bientôt !'
    ],
    typeSoumissionItems: ['Communication orale', 'Communication affichée', 'Scénario'],
    accord: 'D\'accord',
    resume: 'Résumé',
    envoyer: 'Envoyer',
    inscriptionError: 'Merci de corriger les erreurs',
    inscriptionSuccess: 'Votre inscription a bien été envoyée.',
    inscriptionTitle: 'Inscrivez-vous à la compétition et démontrez votre talent en simulation médicale !',
    nom1: 'Nom et prénom du représentant de l\'équipe',
    nom2: 'Nom et prénom du 2eme participant',
    nom3: 'Nom et prénom du 3eme participant',
    nom4: 'Nom et prénom du 4eme participant',
    tel: 'Numéro du téléphone',
    coach: 'Entraîneur',
    inscrir: 'S\'inscrire',
    titleEvent: 'FIRST WORLDCUP IN PEDIATRIC SIMULATION',
    aproposEvent: 'A propos de l’événement',
    aproposContentEvent: 'Participez au First Worldcup of Pediatric Simulation ! Une compétition unique réunissant les meilleurs talents en simulation pédiatrique. Ne manquez pas cet événement exceptionnel !',
    dateHeureEvent: 'Date et heure de l’événement',
    dateHeureContentEvent: 'Du 03-06 juillet 2025',
    comiteOrganisationEvent: 'Comité d’organisation',
    comiteOrganisationContentEvent: 'Pr Nadia El Idrissi Slitine',
    programmeEvent: 'Programme',
    previousDay: 'Jour précédant',
    nextDay: 'Jour suivant',
    locationEvent: 'Location',
    locationContentEvent: 'Faculté de médecine et de pharmacie de Marrakech',
    messagePlusLimirWord: 'Le résumé ne doit pas dépasser 500 mots.',
    telechargerAffiche: 'Télécharger l\'affiche'
  },
  footer: {
    aProposDuCentre: 'A propos du centre',
    reserverSalle: 'Réserver une salle',
    consulterEtatDemande: 'Consulter l’état de votre demande',
    nousContacter: 'Nous contacter',
  },
}

export {fr};